module.exports = __webpack_public_path__ + "static/media/pdf.c7f1adaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/Features/pdf.svg
// module id = 1020
// module chunks = 2